<div class="stepper-container">
  <div class="stepper__header">
    <h3 class="stepper__title">{{ steps[currentStep].title }}</h3>
    <p class="stepper__description">{{ steps[currentStep].description }}</p>
  </div>

  <div class="step-content">
    <div *ngIf="isLoading" class="loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="!isLoading" class="step-content__container">
      <ng-template #stepContainer></ng-template>
    </div>
  </div>

  <div class="stepper-controls" [class.centered]="currentStep === 0">
    <app-button variant="outline" (onClick)="prevStep()" *ngIf="currentStep > 0">Anterior</app-button>
    <app-button (onClick)="nextStep()" *ngIf="currentStep < steps.length - 1"
      [disabled]="isNextStepDisabled()">Siguiente</app-button>
    <app-button *ngIf="currentStep == steps.length - 1" (onClick)="publishForm()"
      [disabled]="isNextStepDisabled()">Publicar</app-button>
  </div>